import { Link } from "react-router-dom";
import { ArrowRight, BarChart3, AlertTriangle, Clock, Calendar, Users, Sparkles, LayoutDashboard, FileText } from "lucide-react";
import { LucideIcon } from "lucide-react";

// Données des features pour la navigation
export const allFeatures = [
  {
    id: "rentabilite",
    icon: BarChart3,
    title: "Rentabilité temps réel",
    description: "Suivez vos marges en continu",
    href: "/product/rentabilite",
    gradient: "from-[#10B981] to-[#059669]",
  },
  {
    id: "jour-critique",
    icon: AlertTriangle,
    title: "Jour Critique",
    description: "Anticipez les dépassements",
    href: "/product/jour-critique",
    gradient: "from-[#EF4444] to-[#DC2626]",
  },
  {
    id: "retards",
    icon: Clock,
    title: "Simulation des retards",
    description: "Impact financier des délais",
    href: "/product/retards",
    gradient: "from-[#F59E0B] to-[#D97706]",
  },
  {
    id: "planning",
    icon: Calendar,
    title: "Planning & Rotations",
    description: "Gérez vos affectations",
    href: "/product/planning",
    gradient: "from-[#06B6D4] to-[#0891B2]",
  },
  {
    id: "equipes",
    icon: Users,
    title: "Gestion d'équipe",
    description: "Coûts main d'œuvre auto",
    href: "/product/equipes",
    gradient: "from-[#8B5CF6] to-[#7C3AED]",
  },
  {
    id: "analyse-ia",
    icon: Sparkles,
    title: "Analyse IA",
    description: "Recommandations intelligentes",
    href: "/product/analyse-ia",
    gradient: "from-[#EC4899] to-[#DB2777]",
  },
  {
    id: "centre-pilotage",
    icon: LayoutDashboard,
    title: "Centre de pilotage",
    description: "Vue d'ensemble complète",
    href: "/product/centre-pilotage",
    gradient: "from-[#3B82F6] to-[#2563EB]",
  },
  {
    id: "rapports",
    icon: FileText,
    title: "Rapports & Documents",
    description: "Suivi & clôture imprimables",
    href: "/product/rapports",
    gradient: "from-[#14B8A6] to-[#0D9488]",
  },
];

interface RelatedFeaturesProps {
  currentFeatureId: string;
  maxItems?: number;
}

const RelatedFeatures = ({ currentFeatureId, maxItems = 3 }: RelatedFeaturesProps) => {
  // Filtrer la feature actuelle et prendre un nombre limité
  const relatedFeatures = allFeatures
    .filter((f) => f.id !== currentFeatureId)
    .slice(0, maxItems);

  return (
    <section className="relative py-20 bg-[#0F172A]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-wider text-[#F59E0B] font-medium mb-3">
            Découvrez aussi
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-white">
            D'autres fonctionnalités pour piloter vos chantiers
          </h2>
        </div>

        <div className={`grid gap-6 ${maxItems === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-4'}`}>
          {relatedFeatures.map((feature) => {
            const Icon = feature.icon;
            return (
              <Link
                key={feature.id}
                to={feature.href}
                className="group rounded-2xl p-[1px] bg-gradient-to-b from-white/[0.1] to-transparent hover:from-[#F59E0B]/30 transition-all duration-300"
              >
                <div className="rounded-2xl bg-[#0F0F14]/90 backdrop-blur-xl p-6 h-full">
                  <div className={`h-12 w-12 rounded-xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-[#F59E0B] transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-white/50 text-sm mb-4">
                    {feature.description}
                  </p>
                  <div className="flex items-center gap-2 text-sm font-medium text-[#F59E0B] group-hover:gap-3 transition-all">
                    En savoir plus
                    <ArrowRight className="h-4 w-4" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Link to all features */}
        <div className="text-center mt-12">
          <Link
            to="/product"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors"
          >
            Voir toutes les fonctionnalités
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RelatedFeatures;
